<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchInfo.searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col"></div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="">
            <tr>
                <th>
                    회사이름
                </th>
            </tr>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listItem;let idx = index;">
                <td>
                    <span role="button" class="btn-link text-decoration-none"
                        (click)="clickSelectCompany(item)">{{item.companyNm}}</span>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>